<!-- 专题课 -->
<template>
    <div class="content">
        <div class="title">
            {{ title }}
        </div>
        <div class="details" v-html="details"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
			imgSrc: "https://case.chongyike.com",
            title: "",
            details: "",
            // 富文本no
            productId: "",
        }
    },
    created(){
        const that = this
        that.productId = this.$route.params.id
        that.getIsvpsProductInfo()
    },
    methods: {
        getIsvpsProductInfo(){
            const that = this
            var data = {
                type: 'getIsvpsProductInfo',
                productId: that.productId,
            }
            this.get("/4/isvps", data).then((res) => {
                if (res.data.code == "success") {
                    var result = JSON.parse(this.decrypt(res.data.result))
                    console.log(result)
                    that.title = result.product_name
                    that.details = result.detail.replace(
                        /<img [^>]*src=['"]([^'"]+)[^>]*>/gi, (match, p1) => {
                            return `<img src='${ p1.indexOf('http') > -1 ? p1 : that.imgSrc + p1}'  style='max-width: 100%;'/>`
                        })
                } 
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    padding-top: 0;
    background-color: #f5f5f5;
}
.title {
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
    padding: 1rem 10px;
    margin: 0 15%;
    color: #444;
    background: #fff;
}
.details {
    margin: 0 15%;
    background-color: #fff;
}
</style>